import Component from 'vue-class-component';
import Feedback from '@/components/Feedback/Feedback';

@Component({
})
export default class FeedbackTab extends Feedback {
}